module.exports = __webpack_public_path__ + "img/venue-placeholder.7c0e632b.jpg";